module.exports = __webpack_public_path__ + "img/history_icon.9a30d56c.svg";